module.exports = __webpack_public_path__ + "img/flower.7ba992b1.png";